export enum PostTypeEnum {
    All = 'all',
    Post = 'post',
    Prayer = 'prayer',
    Testimony = 'testimony',
    Group = 'group',
    Private = 'private',
    Public = 'public',
    Follower = 'follower',
    Anonymous = 'anonymous',
    Responses = 'responses',
    Answered = 'answered',
    Announcement = 'announcement',
}

export enum PostOwnershipEnum {
    ALL = 'all',
    OWN = 'own',
    COMMUNITY = 'community',
}

export const POST_TYPE_LABEL: Record<PostTypeEnum, string> = {
    [PostTypeEnum.All]: 'All',
    [PostTypeEnum.Post]: 'Encouragement',
    [PostTypeEnum.Prayer]: 'Prayer',
    [PostTypeEnum.Testimony]: 'Testimony',
    [PostTypeEnum.Group]: 'Group',
    [PostTypeEnum.Private]: 'Private',
    [PostTypeEnum.Public]: 'Public',
    [PostTypeEnum.Follower]: 'Follower',
    [PostTypeEnum.Anonymous]: 'Anonymous',
    [PostTypeEnum.Responses]: 'Responses',
    [PostTypeEnum.Answered]: 'Answered',
    [PostTypeEnum.Announcement]: 'Announcement',
};

export function getPostTypeLabel(type: PostTypeEnum): string {
    return POST_TYPE_LABEL[type] || type;
}
